import { Menu, MenuItem } from '@mui/material';
import React from 'react';
import { GoSync } from 'react-icons/go';
import Checkbox from './Checkbox';

interface Option<T> {
  hidden?: boolean;
  label: string;
  selected?: boolean;
  onClick: (data: T) => void;
  labelClassName?: string;
}

interface DropdownProps<T> {
  data: T;
  options: Option<T>[];
  loading?: boolean;
  fixed?: boolean;
  label?: string;
  icon?: React.ReactNode;
  className?: string;
  checkboxes?: boolean;
}
function MenuDropdown<T>({
  data, options, loading, label, icon, checkboxes,
}: DropdownProps<T>) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  return (
    <div className="relative inline-block w-full">
      {loading ? (
        <GoSync className="animate-spin" />
      ) : (
        <button
          className={`cursor-pointer flex items-center gap-1 w-full transition-colors duration-200 hover:bg-surface-secondary rounded-3xl ${label ? 'px-2 py-1' : 'text-2xl'}`}
          onClick={handleClick}
        >
          <div className="flex items-center justify-center w-full text-text-primary">
            {label && <span className="text-sm font-medium">{label}</span>}
            <div className='text-2xl text-center text-text-tertiary'>{icon || (!label && '⋮')}</div>
          </div>
        </button>
      )}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        PaperProps={{
          sx: {
            backgroundColor: 'rgb(var(--color-surface-base))',
            border: '1px solid rgb(var(--color-border-secondary))',
            borderRadius: '24px',
            boxShadow: '0px 4px 8px -2px rgba(81, 82, 92, 0.10), 0px 2px 4px -2px rgba(85, 17, 85, 0.17)',
            minWidth: '160px',
          },
        }}
      >
        {options.map((option) => (
          !option.hidden && (
            <MenuItem key={option.label} sx={{
              '&.MuiMenuItem-root': {
                fontFamily: 'Rubik',
                color: 'rgb(var(--color-text-primary))',
                backgroundColor: 'transparent',
                fontSize: '14px',
                padding: '8px 16px',
                '&:hover': {
                  backgroundColor: 'rgb(var(--color-surface-secondary))',
                },
                '&:focus': {
                  backgroundColor: 'rgb(var(--color-surface-secondary))',
                },
              },
            }} onClick={() => {
              option.onClick(data);
              setAnchorEl(null);
            }}><div className={`cursor-pointer ${option.labelClassName} flex items-center gap-2`}>
                {checkboxes && (
                  <div className='relative'>
                    <div className='absolute left-0'>
                      <Checkbox
                        isChecked={option.selected}
                      />
                    </div>
                    <div className='ml-8'>{option.label}</div>
                  </div>
                )}
                {!checkboxes && <div>{option.label}</div>}
              </div></MenuItem>
          )
        ))}
      </Menu>
    </div>
  );
}

export default MenuDropdown;
